import { createApp } from 'vue';
import { createI18n } from 'vue-i18n/index';
import de from '../i18n/de.json';
import AddMarketWrapper from '../components/common/Market/AddMarketWrapper';
import { QuillEditor } from '@vueup/vue-quill/dist/vue-quill.global.prod';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import store from '../../../../FrontendBundle/assets/js/store';

const i18n = createI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    'de': de
  },
})
const section = document.getElementById('add-market-wrapper'); 

let app=createApp(AddMarketWrapper)
app.use(i18n);
app.use(store);
app.component('QuillEditor', QuillEditor);
app.provide('dataset', section.dataset);
app.mount("#add-market-wrapper");